import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Создать")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Удалить")
const _hoisted_3 = {
  key: 1,
  class: "align-start justify-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Выход")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Выберите мероприятие ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialogNewEvent,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogNewEvent) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.newEventName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newEventName) = $event)),
              label: "Название"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, { onClick: _ctx.addNewEvent }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.events)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 0,
          modelValue: _ctx.dialogDeleteEvent,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogDeleteEvent) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.events[_ctx.deleteEventKey]?.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "red",
                  onClick: _ctx.deleteEvent
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.events != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_v_container, { class: "d-flex" }, {
            default: _withCtx(() => [
              (_ctx.userData)
                ? (_openBlock(), _createBlock(_component_v_card_title, { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.userData.email), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.userData)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    onClick: _ctx.exit,
                    variant: "tonal"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _hoisted_6,
              (_ctx.isAdmin)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogNewEvent = true)),
                    icon: "mdi-plus"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event, key) => {
                return (_openBlock(), _createBlock(_component_v_list_item, { key: key }, _createSlots({
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      to: '/scan/'+key,
                      border: "true",
                      variant: "text",
                      size: "big"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(event.name ?? 'Нет названия'), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _hoisted_7,
                    _createVNode(_component_v_divider)
                  ]),
                  _: 2
                }, [
                  (_ctx.isAdmin)
                    ? {
                        name: "append",
                        fn: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            icon: "mdi-delete",
                            size: "small",
                            flat: "",
                            onClick: ($event: any) => {_ctx.dialogDeleteEvent=true;_ctx.deleteEventKey=key.toString()}
                          }, null, 8, ["onClick"])
                        ])
                      }
                    : undefined
                ]), 1024))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createBlock(_component_v_progress_circular, {
          key: 2,
          indeterminate: "",
          class: "pt-12"
        }))
  ], 64))
}